// extracted by mini-css-extract-plugin
export default {"select":"SelectForm_select__OgX-n","large":"SelectForm_large__fY35M"};